<template>
    <section>
        <template>
            <select class="form-control" @change="emit" v-model="selected">
                <option v-for="status in statuses" :key="status.id" :value="status">
                    {{ status.label }}
                </option>
            </select>

            <textarea v-if="selected.comments" type="text" class="form-control" v-model="comment" @input="emit"
                rows="1">
			</textarea>
        </template>

    </section>
</template>
  
<script>
export default {
    props:{
        status:0,
        comments:''
    },
    data() {
        return {
            selected: { id: 0, comments: false, label: this.$t("lang.label.unverified") },
            comment: "",
            statuses: [
                { id: 0, comments: false, label: this.$t("lang.label.unverified") },
                { id: 1, comments: false, label: this.$t("lang.label.verified") },
                { id: 2, comments: true, label: this.$t("lang.label.nonverified") },
            ]
        }
    },
    mounted(){
        if(this.status > 0 ){
            if(this.status == 1){
                this.selected = { id: this.status, comments: false, label: this.$t("lang.label.verified") }
            }else{
                this.selected = { id: this.status, comments: true, label: this.$t("lang.label.nonverified") };
                this.comment = this.comments
            }         
        }
        
    },
    methods: {
        emit() {
            let verificate = {
                status:this.selected.id,
                comment: this.comment,
                label : this.selected.label
            }
            this.$emit("onChange", verificate)
        },
    }
}
</script>